import { FC } from 'react';

import { Button } from '@mui/material';
import { useTranslation } from 'next-i18next';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';
import useCourseEnrollment from '@hooks/course/useCourseEnrollment';

type CourseReviewActionButtonProps = {
  isUpdateReview: boolean;
  setIsOpenCreateOrUpdateCourseReviewDialog: (isOpen: boolean) => void;
};

const CourseReviewActionButton: FC<CourseReviewActionButtonProps> = ({
  isUpdateReview,
  setIsOpenCreateOrUpdateCourseReviewDialog,
}) => {
  const { t } = useTranslation('store_course');

  const { hasEnrolled } = useCourseEnrollment();

  const handleOpenCreateOrUpdateCourseReview = () => {
    setIsOpenCreateOrUpdateCourseReviewDialog(true);
  };

  if (!hasEnrolled) {
    return null;
  }

  if (isUpdateReview) {
    return (
      <Button
        variant="outlined"
        onClick={handleOpenCreateOrUpdateCourseReview}
        sx={{ width: 88, display: 'flex', gap: 1 }}
      >
        <FontAwesomeIcon icon="fa-light fa-pen-to-square" style={{ fontSize: 16 }} />
        {t('course_detail.course_review.update_review')}
      </Button>
    );
  }

  return (
    <Button variant="contained" disableElevation onClick={handleOpenCreateOrUpdateCourseReview} sx={{ width: 98 }}>
      {t('course_detail.course_review.rate_review')}
    </Button>
  );
};

export default CourseReviewActionButton;
